import { AnnotationPrivateCondition } from './annotation.interface';
import { TreeSortMode } from '../models';
import { FileTranscodeInfo, FileTreeNode } from './file-tree.interface';
import { ProjectSection, ProjectSubsection } from './project';
import { TopicInfo } from './topic.interface';
import { OptionInfo, OptionVersion, OptionVersionSimple } from './option-version.interface';
import { MTMCustomFile } from '../services/signed-url';
import { Params } from '@angular/router';

export type CommentInfo = {
  commentId?: string;
  commentVisibility?: AnnotationPrivateCondition;
  handled?: boolean;
};
export type SimpleFilePages = {
  fileId: string;
  pages: SimpleFilePage[];
};
export type SimpleFilePage = {
  id: string;
  name: string;
  signedURL: string;
  rank: number;
  status: string;
  transcodeMetadata: FileTranscodeInfo[];
};

export enum SubsectionViewMode {
  Subsection = 'subsection',
  KPF = 'kpf',
  ShareLinks = 'share-links',
  Release = 'release',
}

export enum CompareOption {
  ABOVE_AND_BELOW = 'aboveAndBelow',
  SIDE_BY_SIDE = 'sideBySide',
  QUIT = 'quit',
}

export type ActiveSubsectionState = {
  section: ProjectSection;
  subsection: ProjectSubsection;
  activeTopic?: TopicInfo;
  activeOption?: OptionInfo;
  activeVersion?: OptionVersionSimple;
  versionData?: OptionVersion;
  versionLoading?: boolean;
  activeFile?: any;
  activeFileId?: string;
  activeFilePages?: SimpleFilePages;
  activePage?: SimpleFilePage;
  pagesLoading?: boolean;
  reviewLink?: any;
  comment?: CommentInfo;
  filesBeingUploaded?: MTMCustomFile[];
  viewMode: SubsectionViewMode;
  activeKpfPath?: FileTreeNode[];
  activeNode?: FileTreeNode;
} | null;
export type SubsectionLockSource = '' | 'share-link' | 'release';

export type ProjectSubSectionUIState = {
  explorerCollapsed?: boolean;
  commentsCollapsed?: boolean;
  rightPanelView: 'comment' | 'task';
  cinemaMode?: boolean;
  compareMode?: boolean;
  compareViewMode?: CompareOption;
  orderBy?: TreeSortMode;
  isNavigationAffected?: boolean; // if true, navigation will be affected by the current subsection state
  isShareLinkPreview?: boolean;
  isReleasePreview?: boolean;
  contentLocked?: boolean; // if true, right panel content is locked and cannot be changed
  contentLockSource?: SubsectionLockSource;
  isSectionExpanded?: boolean;
} | null;
export type SubsectionNavigationParams = {
  projectId: string;
  sectionId: string;
  subsectionId: string;
  topicId?: string;
  optionId?: string;
  versionNumber?: number;
  fileId?: string;
  page?: number;
  folderId?: string;
  navigationType?: 'subsection' | 'kpf' | 'share-link' | 'release';
  shareLinkId?: string;
  isNewItem?: boolean;
  shareAssetId?: string;
  releaseId?: string;
  releaseAssetId?: string;
  releaseFileId?: string;
  driveDirectoryUuid?: string; // drive mode: target Drive directory (?dirId) for the section/subsection
};
export type MoveSubsectionFilesParams = {
  sourceFile: {
    projectId: string;
    sectionId: string;
    subSectionId: string;
    optionId: string;
    version: number;
    files: [string];
  };
  destinationFile: {
    projectId: string;
    sectionId: string;
    subSectionId: string;
    optionId: string;
    version: number;
  };
};
export type GetMediaObjectParams = {
  projectId: string;
  sectionId: string;
  subSectionId: string;
  topicId?: string;
  optionId?: string;
  version?: number;
};

export interface VersionCreationParams {
  projectId: string;
  sectionId: string;
  subSectionId: string;
  topicId: string;
  optionId: string;
  version: number;
}

export interface TopicCreationResponse {
  updatedAt: string;
  key: {
    project: string;
    section: string;
    subsection: string;
    topicId: string;
  };
  title: string;
  description: string;
}

export interface ReviewLinkNavigationParams {
  topicId?: string;
  optionId?: string;
  versionNumber?: number;
  fileId?: string;
  id: string;
}

export interface SubsectionUrlConfig {
  condition: () => boolean;
  path: () => string;
  queryParams: () => Params;
}
